import leadsAPI from "@/api/leads";

const getDefaultState = () => ({
  isAttachAccountLoading: false,
  isAttachAccountError: false,
  isAttachAccountErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  ATTACH_ACCOUNT_BEGIN(state) {
    state.isAttachAccountLoading = true;
    state.isAttachAccountError = false;
    state.isAttachAccountErrorResponse = null;
  },
  ATTACH_ACCOUNT_SUCCESS(state) {
    state.isAttachAccountLoading = false;
  },
  ATTACH_ACCOUNT_ERROR(state, error) {
    state.isAttachAccountLoading = false;
    state.isAttachAccountError = true;
    state.isAttachAccountErrorResponse = error;
  },
  
  RESET_ATTACH_ACCOUNT(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async attachAccount({ commit, dispatch }, { lead_id, account_id } ) {
    commit("ATTACH_ACCOUNT_BEGIN");
    try {
      await leadsAPI.attachToAccount(lead_id, account_id);
      dispatch("alerts/setAlert", { type: "success", message: 'Billing account linked successfully' }, { root: true });
    } catch(error) {
      commit("ATTACH_ACCOUNT_ERROR", error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },
};

const getters = {
  getIsAttachAccountLoading: state => state.isAttachAccountLoading,
  getIsAttachAccountError: state => state.isAttachAccountError,
  getIsAttachAccountErrorResponse: state => state.isAttachAccountErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
